/*eslint-disable*/
import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Link, NavLink, useLocation } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import PerfectScrollbar from 'react-perfect-scrollbar';

// core components
import styles from "assets/jss/material-dashboard-react/components/sidebarStyle.js";
import { useTranslation } from "react-i18next";
import { useMedia } from 'react-use';
import { ReactComponent as UserCircleIcon } from "assets/icons/user-circle.svg";
import { Box, SvgIcon, Tooltip } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { getAuthInfo, getOrganizationName, getUserInfoSidebar } from "../../store/slices/auth";
import { getExtendSidebar, toggleSidebar } from "store/slices/layout";
import AppConfig, { SYSTEM_ROLE } from "config/AppConfig";
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import { drawerWidth } from "assets/jss/material-dashboard-react";

const { APPROVAL_STATUS } = AppConfig;
const useStyles = makeStyles((theme) => ({
  ...styles(theme),
  bg: {
    backgroundColor: '#f9f7f6'
  },
  rotate: {
    transform: 'rotate(180deg)'
  },
  toggleSidebar: {
    '&:hover': {
      cursor: 'pointer'
    }
  },
  boxSidebar: {
    flex: "0 0 auto"
  },
  boxSidebarScroll: {
    flex: "1 0 auto",
    display: "flex"
  },
  collapse: {
    width: "80px!important",
    minWidth: "80px"
  },
  wrapper: {
    position: 'relative',
    width: drawerWidth
  }
}));

const UserSidebar = (props) => {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const classes = useStyles();
  const sideBar = useRef();

  const userInfo = useSelector(getAuthInfo);
  const organizationName = useSelector(getOrganizationName);
  const extendSidebar = useSelector(getExtendSidebar);
  const userInfoSidebar = useSelector(getUserInfoSidebar);

  const [authInfo, setAuthInfo] = useState({
    organizationName: '',
    firstName: '',
    lastName: ''
  });
  const {
    approvalStatus
  } = userInfo;

  
  // verifies if routeName is the one active (in browser input)
  function activeRoute(routeName) {
    return window.location.href.indexOf(routeName) > -1 ? true : false;
  }
  const {
    color, logo, image, logoText, routes, open,
    handleDrawerToggle
  } = props;

  const below959 = useMedia('(max-width: 959px)');
  const below600 = useMedia('(max-width: 600px)');

  useEffect(() => {
    if(userInfoSidebar) {
      setAuthInfo(userInfoSidebar);
    }
  }, [userInfoSidebar]);

  const filterRoute = e => {
    if (e.activeStatus && approvalStatus !== APPROVAL_STATUS.ACTIVE) {
      return;
    }
    if (e.accessRole === '*') {
      return e.isMenu && location.pathname.includes(e.layout);
    }
    if (e.accessRole && e.accessClient) {
      return e.isMenu && location.pathname.includes(e.layout)
        && e.accessRole && e.accessRole.includes(userInfo.role) && e.accessClient && e.accessClient.includes(userInfo.clientType);
    } else if (e.accessRole && !e.accessClient) {
      return e.isMenu && location.pathname.includes(e.layout)
        && e.accessRole && e.accessRole.includes(userInfo.role)
    } else {
      return e.isMenu && location.pathname.includes(e.layout);
    }
  }
  const links = (
    <List className={classes.list}>
      {routes.filter(filterRoute).map((prop, key) => {
        let activePro = " ";
        let listItemClasses;
        listItemClasses = classNames({
          [" " + classes[color]]: activeRoute(prop.path)
        });
        const violetFontClasses = classNames({
          [" " + classes.violetFont]: activeRoute(prop.path)
        });
        return (
          <NavLink
            to={prop.path}
            className={activePro + classes.item}
            activeClassName="active"
            key={key}
          >
            <ListItem button className={classes.itemLink + listItemClasses}>
              {typeof prop.icon === "object" && prop.icon.type === 'font-awesome' ? (
                <Tooltip title={t(prop.name)} placement="right" disableHoverListener={!below959 && extendSidebar}>
                  <i className={classNames(classes.itemIcon, prop.icon.icon)} />
                </Tooltip>
              ) : typeof prop.icon === "string" ? (
                <Tooltip title={t(prop.name)} placement="right" disableHoverListener={!below959 && extendSidebar}>
                  <img
                    src={prop.icon}
                    className={classNames(classes.itemIcon)}
                  />
                </Tooltip>
              ) : (
                <Tooltip title={t(prop.name)} placement="right" disableHoverListener={!below959 && extendSidebar}>
                  <prop.icon
                    className={classNames(classes.itemIcon)}
                  />
                </Tooltip>
              )}
              {
                !below959 && extendSidebar && (
                  <ListItemText
                    primary={t(prop.name)}
                    className={classNames(classes.itemText, violetFontClasses)}
                    disableTypography={true}
                  />
                )
              }
            </ListItem>
          </NavLink>
        );
      })}
    </List>
  );
  const user = (
    <List className={classes.list}>
      <div className={classes.item}>
        <div className={`${classes.itemLink} ${classes.wrapUserInfo}`}>
          <SvgIcon component={UserCircleIcon} viewBox="0 0 512 512" className={classes.itemIcon} />
          {
            !below959 && extendSidebar && (
              <div className={classNames(classes.userInfo)}>
                <span className="font-weight-bold">
                  {
                    userInfo.role === SYSTEM_ROLE.HOSPITAL_ADMIN ||
                      userInfo.role === SYSTEM_ROLE.HOSPITAL_OTHER
                      ? (
                        `${authInfo.organizationName || organizationName}`
                      )
                      : (
                        `${authInfo.firstName || userInfo.firstName} ${authInfo.lastName ||  userInfo.lastName}`
                      )
                  }
                </span>
                <span>
                  {t(`user_role.${userInfo.role}`)}
                </span>
              </div>
            )
          }
        </div>
      </div>
      {
        routes.filter(e => e.isMenuTop).map((prop, key) => {
          const listItemClasses = classNames({
            [" " + classes[color]]: activeRoute(prop.path)
          });
          const violetFontClasses = classNames({
            [" " + classes.violetFont]: activeRoute(prop.path)
          });
          return (
            <NavLink
              to={prop.path}
              className={classes.item}
              activeClassName="active"
              key={`sb-user-${key}`}
            >
              <ListItem button className={classes.itemLink + listItemClasses}>
                <Tooltip title={t(prop.name)} placement="right" disableHoverListener={!below959 && extendSidebar}>
                  <SvgIcon component={prop.icon} viewBox="0 0 512 512" className={classNames(classes.itemSmallIcon)} />
                </Tooltip>
                {
                  !below959 && extendSidebar && (
                    <ListItemText
                      primary={t(prop.name)}
                      className={classNames(classes.itemText)}
                      disableTypography={true}
                    />
                  )
                }
              </ListItem>
            </NavLink>
          )
        })
      }
    </List>
  );
  const bottom = routes.filter(e => e.isMenuBottom)[0] && (
    <List className={classes.list}>
      {routes.filter(e => e.isMenuBottom).map((prop, key) => {
        let activePro = " ";
        let listItemClasses;
        listItemClasses = classNames({
          [" " + classes[color]]: activeRoute(prop.path)
        });
        const violetFontClasses = classNames({
          [" " + classes.violetFont]: activeRoute(prop.path)
        });
        return (
          <NavLink
            to={prop.path}
            className={activePro + classes.item}
            activeClassName="active"
            key={key}
          >
            {
              !below959 && extendSidebar ?
                (
                  <ListItem button className={classes.itemLinkBottom + listItemClasses}>
                    <ListItemText
                      primary={t(prop.name)}
                      className={classNames(violetFontClasses)}
                      disableTypography={true}
                    />
                    <i className={`fas fa-chevron-right ${classes.itemIconBottom}`}></i>
                  </ListItem>
                )
                :
                (
                  <ListItem button className={classes.itemLink + listItemClasses}>
                    <Tooltip title={t(prop.name)} placement="right" disableHoverListener={!below959 && extendSidebar}>
                      <SvgIcon component={prop.icon} viewBox="0 0 512 512" className={classes.itemIcon} />
                    </Tooltip>
                  </ListItem>
                )
            }
          </NavLink>
        );
      })}
    </List>
  );

  useEffect(() => {
    if (sideBar && sideBar.current) {
      if (navigator.platform.indexOf("Win") > -1) {
        ps = new PerfectScrollbar(sideBar.current, {
          suppressScrollX: true,
          suppressScrollY: false,
        });
        // document.body.style.overflow = "hidden";
      }
    }
  }, [sideBar]);

  return (
    <Box className={classNames({
      [classes.boxSidebar]: true,
      [classes.wrapper]: !below959,
      [classes.collapse]: !below600 && (!extendSidebar || below959)
    })}>
      <Drawer
        variant="persistent"
        anchor="left"
        open={open}
        classes={{
          paper: classNames({
            [classes.drawerPaper]: true,
            [classes.bg]: true,
            [classes.collapse]: !extendSidebar
          }),
        }}
        onClose={props.handleDrawerToggle}
        ModalProps={{
          keepMounted: true // Better open performance on mobile.
        }}
      >
        {user}
        <PerfectScrollbar
          className={classNames({
            [classes.sidebarWrapper]: true,
            [classes.collapse]: !extendSidebar
          })}
          options={{
            suppressScrollX: true,
            suppressScrollY: false
          }}
        >
          {links}
          {routes.find(e => e.isMenuBottom) && bottom}
        </PerfectScrollbar>
        {
          !below959 && (
            <Box
              padding="1rem 0.25rem"
              display="flex"
              alignItems="center"
              justifyContent="center"
              className={classes.toggleSidebar}
              onClick={() => dispatch(toggleSidebar(!extendSidebar))}
            >
              <DoubleArrowIcon
                className={classNames({
                  [classes.rotate]: extendSidebar
                })}
              />
              {
                extendSidebar && (
                  <span style={{
                    fontSize: 14
                  }} className="ml-3">{t("label.collapseSidebar")}</span>
                )
              }
            </Box>
          )
        }
      </Drawer>
    </Box>
  );
}

UserSidebar.propTypes = {
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  bgColor: PropTypes.oneOf(["purple", "blue", "green", "orange", "red"]),
  logo: PropTypes.string,
  image: PropTypes.string,
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  open: PropTypes.bool
};

export default UserSidebar;
